export default __webpack_public_path__ + "static/media/dots-up.c60fd939.svg";